import { AMBER, NAVY, BORDER_COLOR, bubbleStyle } from '../../styles/tokens';

const TYPE_LABELS = {
  vacation: 'Vacaciones',
  sick: 'Enfermedad',
  personal: 'Personal',
};

const TYPE_COLORS = {
  vacation: '#2563eb',
  sick: '#dc2626',
  personal: '#7c3aed',
};

export default function PTOBalanceCard({ balances = [] }) {
  if (!balances.length) {
    return (
      <div style={{ ...bubbleStyle, padding: '16px 20px', marginBottom: 16, textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>
        No hay saldos de PTO configurados para este año.
      </div>
    );
  }

  return (
    <div style={{ ...bubbleStyle, padding: '16px 20px', marginBottom: 16 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: NAVY, marginBottom: 12 }}>
        Saldos de Tiempo Libre
      </div>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        {balances.map(b => {
          const total = parseFloat(b.total_days);
          const used  = parseFloat(b.used_days);
          const pending = parseFloat(b.pending_days);
          const available = total - used - pending;
          const pct = total > 0 ? ((used + pending) / total) * 100 : 0;
          const color = TYPE_COLORS[b.type] || AMBER;

          return (
            <div key={b.type} style={{
              flex: '1 1 140px', minWidth: 140,
              background: '#f8fafc', borderRadius: 10,
              border: `1px solid ${BORDER_COLOR}`, padding: '12px 14px',
            }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: color, textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 6 }}>
                {TYPE_LABELS[b.type] || b.type}
              </div>
              <div style={{ fontSize: 22, fontWeight: 700, color: NAVY, lineHeight: 1 }}>
                {available}
              </div>
              <div style={{ fontSize: 11, color: '#64748b', marginTop: 2 }}>
                disponibles de {total}
              </div>
              {/* Progress bar */}
              <div style={{ height: 4, background: '#e2e8f0', borderRadius: 2, marginTop: 8 }}>
                <div style={{
                  height: '100%', borderRadius: 2,
                  width: `${Math.min(pct, 100)}%`,
                  background: pct > 90 ? '#dc2626' : color,
                  transition: 'width 0.3s ease',
                }} />
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, color: '#94a3b8', marginTop: 4 }}>
                <span>Usado: {used}</span>
                <span>Pendiente: {pending}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
